export const calculateMargin = (dataset) => {
  if (!dataset || dataset.length === 0) {
    return {
      left: 60,
      right: 10,
      top: 35,
      bottom: 40,
    };
  }

  // Find the first data point to determine the structure
  const firstDataPoint = dataset[0];
  let valueKey = null;

  // Check for different possible value keys
  if (firstDataPoint.totalInvested !== undefined) {
    valueKey = 'totalInvested';
  } else if (firstDataPoint.value !== undefined) {
    valueKey = 'value';
  } else if (firstDataPoint.total !== undefined) {
    valueKey = 'total';
  } else {
    // Fallback: find any numeric property
    const numericKeys = Object.keys(firstDataPoint).filter(key =>
      typeof firstDataPoint[key] === 'number'
    );
    valueKey = numericKeys[0] || 'value';
  }

  const maxLabelLength = Math.max(...dataset.map((data) => {
    const value = data[valueKey];
    return value !== undefined && value !== null ? value.toString().length : 0;
  }));

  return {
    left: Math.max(maxLabelLength * 6.5, 60),
    right: 10,
    top: 35,
    bottom: 40,
  };
};